import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-solve",
  "use": "icon-solve-usage",
  "viewBox": "0 0 29.113 10.213",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29.113 10.213\" id=\"icon-solve\"><g transform=\"translate(-2959.116 2166.689)\"><path d=\"M2970.954-2166.689h-6.766a5.072,5.072,0,0,0-5.072,5.072,5.072,5.072,0,0,0,5.072,5.073h6.766l3.3-5.073Z\" fill=\"#fff\" /><path d=\"M2984.259-2165.689l2.777,4.126-2.564,4.087h-9.832l2.2-3.377.343-.526-.326-.537-2.284-3.773h9.688m.532-1h-12l3.2,5.291-3.2,4.922h12.229l3.2-5.106-3.438-5.107Z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol